import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export interface IGetAuthFederationConnectorsResponse {
  connectors: Array<{
    luid: string;
    connectorClass: string;
    audience: string;
  }>;
}

export function getAuthFederationConnectorsRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'GET',
    endpoint: 'auth-federation/admin/connectors',
    serverWideRequest: false
  };
}

export function callGetAuthFederationConnectorsRequest(): Promise<IGetAuthFederationConnectorsResponse> {
  return makeJsonRestApiRequest<null, any>({
    config: getAuthFederationConnectorsRequestConfig(),
    request: null
  }).then((response) => {
    // Transform REST API response: { authFederationConnectors: { connector: [...] } } -> { connectors: [...] }
    const authFederationConnectors = response.authFederationConnectors || {};
    const connectorArray = authFederationConnectors.connector || [];
    return {
      connectors: Array.isArray(connectorArray) ? connectorArray : [connectorArray]
    };
  });
}
